module.exports = __webpack_public_path__ + "media/images/pc/banner/visit_reserve-d159d8e1f391aa7157e24bf3c0398e8d.png";